import customAxiosInterceptor from "../customAxiosInterceptor";

export const getPromoCodeDiscountThunk = async (data, thunkAPI) => {
  try {
    const response = await customAxiosInterceptor.get("/promo-code", {
      params: { name: data },
    });
    return response.data.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
};
